import {
  useEmbedPano,
  useGetFarmDetails,
  useGetFieldDetails,
  useCurrentField,
} from "shared/hooks";
import PageTopMenu from "components/PageTopMenu";
import PageSideMenu from "components/PageSideMenu";
import PageBottomMenu from "components/PageBottomMenu";
import {
  // Key Buttons (major krpano features)
  useTopDownView,
  useMeasureMode,
  // useCompareMode,
  useShowMap,
  // Settings (minor krpano features)
  useAutoRotate,
  useZFilterPlugin,
  useGetLayers,
  useShowHideLayers,
  // Misc krpano features
  useInitialPoi,
  useInitialView,
} from "shared/hooks/features";
import PanelFarmDetails from "components/PanelFarmDetails";
import PanelReportView from "components/PanelReportView";
import PanelFieldSelector from "components/PanelFieldSelector";
import PanelSettings from "components/PanelSettings";
import KeyButtons from "components/KeyButtons";
import {
  FeatureLayer,
  GetCoordinates,
  Measure,
  MeasureButtons,
  PoiCreate,
  PoiRead,
  PoiDelete,
} from "components/krpano";
import { useAppSelector } from "app/hooks";
import PanelSphereSelector from "components/PanelSphereSelector";
import Spinner from "shared/components/Spinner";
//
// Additional library styles
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "react-calendar/dist/Calendar.css";

// IDEA: Lazy load components that are not used on initial load

/**
 *
 * @returns
 */
const App: React.FC = () => {
  const krpanoLoaded = useEmbedPano();
  // Load farm and field details
  const farmLoaded = useGetFarmDetails(krpanoLoaded);
  const fieldLoaded = useGetFieldDetails(krpanoLoaded, farmLoaded);
  const krpanoFeaturesReady = krpanoLoaded && farmLoaded && fieldLoaded;
  // Load krpano features
  useCurrentField(krpanoFeaturesReady);
  // Key Buttons (major krpano features)
  useTopDownView(krpanoFeaturesReady);
  useMeasureMode(krpanoFeaturesReady);
  // useCompareMode(krpanoFeaturesReady);
  useShowMap(krpanoFeaturesReady);
  // Settings (minor krpano features)
  useAutoRotate(krpanoFeaturesReady);
  useZFilterPlugin(krpanoFeaturesReady);
  useGetLayers(krpanoFeaturesReady);
  useShowHideLayers(krpanoFeaturesReady);
  // Misc krpano features
  useInitialPoi(krpanoFeaturesReady);
  useInitialView(krpanoFeaturesReady);

  const imperialUnits = useAppSelector((state) => state.panorama.imperialUnits);

  const measureMode = useAppSelector((state) => state.krpano.measureMode);

  const menusInView = fieldLoaded && measureMode !== "IN_PROGRESS";

  return (
    <div className="Application">
      <PageTopMenu />
      <PageSideMenu menusInView={menusInView} />
      <PageBottomMenu menusInView={menusInView} />
      <KeyButtons menusInView={menusInView} />
      <MeasureButtons />
      {/* Panels */}
      <PanelFarmDetails />
      <PanelReportView />
      <PanelFieldSelector />
      <PanelSettings />
      {/* Sphere Date Selector */}
      <PanelSphereSelector />
      {/* krpano Features */}
      {/* krpano: Get Coordinates */}
      <GetCoordinates imperialUnits={imperialUnits} />
      {/* krpano: Measure */}
      <Measure measureMode={measureMode} imperialUnits={imperialUnits} />
      {/* krpano: Feature Layers */}
      {/* NOTE: Below `PoiRead` for z-index purposes */}
      <FeatureLayer />
      {/* krpano: POI (aka Scout Point) */}
      <PoiCreate />
      <PoiRead />
      <PoiDelete />
      {/* Misc */}
      <Spinner
        show={!krpanoFeaturesReady}
        additionalClassNames="TopLevelSpinner"
        underlayClass="NoUnderlay"
      />
    </div>
  );
};

export default App;
